import { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toastify } from '#ui-kit';
import { Head, LoadingContent } from '#components';
import { HeadUnderlineVariant } from '#components.types';

import { RestaurantsService } from '#services/restaurants';
import Form from './containers/Form';
import { RestaurantResponse } from 'types';

export default () => {
  const location = useLocation();
  const { id } = useParams();
  const { restaurant: stateRestaurant } = (location.state || {}) as {
    restaurant?: RestaurantResponse;
  };

  const [restaurant, setRestaurant] = useState<RestaurantResponse | undefined>(
    stateRestaurant,
  );
  const [loading, setLoading] = useState<boolean>(!stateRestaurant);

  useEffect(() => {
    const fetchData = async () => {
      if (!stateRestaurant && id) {
        try {
          const service = new RestaurantsService();
          const result = await service.getRestaurant(id);
          setRestaurant(result);
        } catch {
          toastify.error('Не удалось загрузить данные ресторана');
        } finally {
          setLoading(false);
        }
      }
    };
    fetchData();
  }, [id]);

  return (
    <>
      <Head
        {...{
          label: 'Данные ресторана',
          underlineVariant: HeadUnderlineVariant.Secondary,
        }}
      />
      {loading ? (
        <LoadingContent />
      ) : restaurant ? (
        <Form data={restaurant} />
      ) : null}
    </>
  );
};
